<template>
<Dialog v-model="visible">

  <template slot="title">
    <span class="title">{{$t('link.add_device')}}</span>
  </template>

  <v-container class="pa-5">
    <p class="subtitle-1" v-html="$t('link.connect_ap',{val:hotspotName})"></p>
  </v-container>

  <template slot="actions">
    <v-btn outlined color="secondary" @click="visible=false">{{ $t('link.cancel') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn outlined color="primary" @click="redirect">{{ $t('link.next_step') }}</v-btn>
  </template>

</Dialog>
</template>

<script>
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'

export default {
  name: 'LinkDialog',
  mixins: [BaseDialog],
  components: {
    Dialog
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    hotspotName() {
      return process.env.VUE_APP_AP_MODE_SSID;
    }
  },
  methods: {
    redirect() {
      const params = new URLSearchParams();
      params.append('id', this.user.uid);
      params.append('name', this.user.displayName);
      params.append('email', this.user.email);
      params.append('provider', 'Luffanet');
      let host = process.env.VUE_APP_AP_MODE_HOST;
      let url = `${host}?${params}`;
      window.location.href = url;
    }
  }
}
</script>
